module.exports = __webpack_public_path__ + "static/media/PostModalPort.60f77cd9.png";